/**
 * 송금 내역 요약 섹션
 */
import React from 'react';

interface SummarySectionProps {
    totalCount: number;
    totalTransferAmt: number;
}

const SummarySection: React.FC<SummarySectionProps> = ({
    totalCount,
    totalTransferAmt
}) => {
    const formatAmount = (amount: number) => {
        return amount.toLocaleString('ko-KR') + '원';
    };

    return (
        <div className="card">
            <div className="card-body">
                <div className="summary-container">
                    <div className="summary-item">
                        <span className="summary-label">총 송금 건수</span>
                        <span className="summary-amount">
                            {totalCount.toLocaleString()}건
                        </span>
                    </div>
                    <div className="summary-item summary-total">
                        <span className="summary-label">총 송금액</span>
                        <span className="summary-amount amount-transfer">
                            {formatAmount(totalTransferAmt)}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SummarySection;
